'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_forms_FormLabel_FormLabelRequiredText = require('./FormLabelRequiredText.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1i2of_1";
const asterisk = "_asterisk_1i2of_45";
const styles = {
	root: root,
	asterisk: asterisk
};

const FormLabel = ({ alignItems = "center", children, htmlFor = void 0, isDisabled = void 0, isErrored = void 0, isRequired = void 0, isSelected = void 0, justifyContent = "start", requiredText = void 0, size = "medium" }) => {
  return React__default.default.createElement(
    "label",
    { className: styles.root, "data-align-items": alignItems, "data-justify-content": justifyContent, "data-size": size, "data-state": [
      isSelected && "selected",
      isErrored && "errored",
      isDisabled && "disabled"
    ].filter(Boolean).join(" ") || void 0, "data-zds": true, htmlFor },
    children,
    isRequired && React__default.default.createElement("abbr", { className: styles.asterisk, title: "required" }, "*"),
    isRequired ? requiredText ? React__default.default.createElement(components_forms_FormLabel_FormLabelRequiredText.FormLabelRequiredText, { isDisabled }, requiredText) : React__default.default.createElement(components_forms_FormLabel_FormLabelRequiredText.FormLabelRequiredText, { isDisabled }) : null
  );
};

exports.FormLabel = FormLabel;
//# sourceMappingURL=FormLabel.cjs.js.map
